import React, { useContext, useRef } from 'react';
import AlertModal from 'components/Modals/AlertModal/AlertModal';

export const AlertContext = React.createContext(null);

export default function AlertProvider({ children }) {
  const alert = useRef();

  return (
    <AlertContext.Provider value={alert}>
      {children}
      <AlertModal timer={5000} ref={alert} />
    </AlertContext.Provider>
  );
}

export function useAlert() {
  return useContext(AlertContext);
}
